/* tslint:disable */
/* eslint-disable */
/**
 * Kapybro Frontend Api Service
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: hello@roguepaws.dev
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SponsorsLabelingConfig
 */
export interface SponsorsLabelingConfig {
    /**
     * 
     * @type {boolean}
     * @memberof SponsorsLabelingConfig
     */
    enabled: boolean;
    /**
     * 
     * @type {string}
     * @memberof SponsorsLabelingConfig
     */
    label?: string;
    /**
     * 
     * @type {boolean}
     * @memberof SponsorsLabelingConfig
     */
    includePastSponsors?: boolean;
}

export function SponsorsLabelingConfigFromJSON(json: any): SponsorsLabelingConfig {
    return SponsorsLabelingConfigFromJSONTyped(json, false);
}

export function SponsorsLabelingConfigFromJSONTyped(json: any, ignoreDiscriminator: boolean): SponsorsLabelingConfig {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'enabled': json['enabled'],
        'label': !exists(json, 'label') ? undefined : json['label'],
        'includePastSponsors': !exists(json, 'includePastSponsors') ? undefined : json['includePastSponsors'],
    };
}

export function SponsorsLabelingConfigToJSON(value?: SponsorsLabelingConfig | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'enabled': value.enabled,
        'label': value.label,
        'includePastSponsors': value.includePastSponsors,
    };
}

